(function () {
	var btn = document.querySelector(".scroll-top");
	var ticking = false;

	function update() {
		ticking = false;
		if (!btn) return;
		if (window.scrollY > document.documentElement.clientHeight) {
			btn.classList.add("show");
		} else {
			btn.classList.remove("show");
		}
	}

	// Single passive + rAF-throttled scroll listener (bound once)
	window.addEventListener("scroll", function () {
		if (ticking) return;
		ticking = true;
		window.requestAnimationFrame(update);
	}, { passive: true });

	function bindClick() {
		var b = document.querySelector(".scroll-top");
		if (b) {
			btn = b;
			if (!b._stBound) {
				b._stBound = true;
				b.addEventListener("click", function () {
					window.scrollTo({ top: 0, behavior: "smooth" });
				});
			}
		}
	}

	bindClick();
	document.addEventListener("shopify:section:load", bindClick);
})();
